"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringTypeNormalizerExceptFirstLetter = stringTypeNormalizerExceptFirstLetter;
exports.lowerCaseAllWordsExceptFirstLetter = lowerCaseAllWordsExceptFirstLetter;

var stringTypeNormalizer = exports.stringTypeNormalizer = function (type) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return type ? type.replace(new RegExp(separator, "g"), " ").toLowerCase() : "";
};

function stringTypeNormalizerExceptFirstLetter(type) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  return type ? type.charAt(0) + type.substr(1).replace(new RegExp(separator, "g"), " ").toLowerCase() : "";
}

function lowerCaseAllWordsExceptFirstLetter(value) {
  return value ? value.charAt(0) + value.substr(1).toLowerCase() : "";
}